import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../Assets/Css/HomeCss/TopHealthyArticles.css';
import { fetchLatestBlogs } from '../Services/BlogService';

const TopHealthyArticles = () => {
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchLatestBlogs(4)
            .then((list) => setBlogs(Array.isArray(list) ? list : []))
            .catch((err) => console.log(err))
            .finally(() => setIsLoading(false));
    }, []);

    // Nothing published yet: hide the section instead of showing an empty block
    if (!isLoading && blogs.length === 0) return null;

    return (
        <section className="top-healthy-articles">
            <div className="container">
                <div className="header-container">
                    <h2>Top Healthy Articles</h2>
                    <Link to="/blogs" className="view-all"><u>View All</u></Link>
                </div>

                <div className="articles-container">
                    {isLoading
                        ? [1, 2, 3, 4].map((n) => (
                            <div key={n} className="article article-skeleton" aria-hidden="true">
                                <div className="article-img-wrap animate-pulse bg-gray-200"></div>
                                <div className="h-4 mt-4 mx-6 rounded bg-gray-200 animate-pulse"></div>
                            </div>
                        ))
                        : blogs.map((blog) => (
                            <Link
                                key={blog.id}
                                to={`/blog/${blog.slug}`}
                                className="article"
                            >
                                <div className="article-img-wrap">
                                    <img src={blog.image_url || "/img/blog1.png"} className="article-img" alt={blog.title} loading="lazy" />
                                </div>
                                <h4>{blog.title}</h4>
                            </Link>
                        ))}
                </div>
            </div>
        </section>
    );
};

export default TopHealthyArticles;
